
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbPortariaFuncionario extends AppService {

  abstract getAllVisitantes(filter: AppFilter): Observable<any>;
  abstract getFotoVisitante(id: number): Observable<Blob>;
}